import { render, staticRenderFns } from "./SupportFormCard.vue?vue&type=template&id=c9e6849e&scoped=true&"
import script from "./SupportFormCard.vue?vue&type=script&lang=js&"
export * from "./SupportFormCard.vue?vue&type=script&lang=js&"
import style0 from "./SupportFormCard.vue?vue&type=style&index=0&id=c9e6849e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e6849e",
  null
  
)

export default component.exports